module.exports = __webpack_public_path__ + "static/img/f1.e62a756.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/common/f1.jpg
// module id = 5/6G
// module chunks = 11